// extracted by mini-css-extract-plugin
export default {"container":"SO-z","topReviewHeading":"TO-z","criticalReview":"UO-z","favorableReview":"VO-z","vsSeparator":"WO-z"};